import React from "react";
import moment, { Moment } from "moment";
import { Box, Stack } from "@mui/material";
import ButtonGroup from "./ButtonGroup";
import DatePicker from "../../components/DatePickers";

interface HeaderProps {
  selectedDate: moment.Moment;
  onDateChange: (date: Moment) => void;
  showButtonGroup?: boolean;
  showAd?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  selectedDate,
  onDateChange,
  showButtonGroup = true,
  showAd = true
}): React.ReactElement => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }}
  >
    <Stack spacing={2}>
      <DatePicker date={selectedDate} onChange={onDateChange} showAd={showAd} />

      {showButtonGroup && (
        <Box display="flex" justifyContent="flex-end">
          <ButtonGroup />
        </Box>
      )}
    </Stack>
  </Box>
);

export default Header;
